export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENT_DETAIL = 'GET_EVENT_DETAIL';
export const MARK_UNMARK_RSVP = 'MARK_UNMARK_RSVP';
export const GET_LIVESTREAM_DETAIL = 'GET_LIVESTREAM_DETAIL';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const MARK_LIVESTREAM_UNMARK_RSVP = 'MARK_LIVESTREAM_UNMARK_RSVP';
export const GET_FILTER_EVENTS = 'GET_FILTER_EVENTS';
export const GET_EVENT_DATE_COUNT = 'GET_EVENT_DATE_COUNT';
export const MARK_EVENT_START = 'MARK_EVENT_START';
